export enum partTypeEnum {
    headLeft = 'headLeft',
    headRight = 'headRight',
    core = 'core',
    bodyA = 'bodyA',
    bodyB = 'bodyB'
}